import { render, staticRenderFns } from "./VideoStream.vue?vue&type=template&id=362db040"
import script from "./video-stream.js?vue&type=script&lang=js&external"
export * from "./video-stream.js?vue&type=script&lang=js&external"
import style0 from "./VideoStream.vue?vue&type=style&index=0&id=362db040&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VProgressCircular})
